<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-auto">

            <div class="uk-modal-header uk-flex uk-flex-left uk-flex-bottom">
                <h4 class="uk-margin-remove">해외오더 작성하기</h4>
                <div class="uk-margin-left">
                    이미 배송이 끝난 상품의 해외오더 정보를 나중에 입력할때 사용합니다
                </div>
            </div>

            <div class="uk-modal-body uk-padding-small" >
                <div class="uk-flex uk-flex-between">
                    <div class="uk-width-medium uk-margin-right">
                        <!-- 주문정보 -->
                        <app-input-ex
                            class="uk-margin-small-bottom"
                            type="text"

                            v-model="order.buy_order_code"
                            label="해외주문번호"
                            placeholder=""

                            :validate-rules="{required: true}"
                            required
                        > </app-input-ex>

                        <app-input-ex
                            class="uk-margin-small-bottom"
                            type="text"

                            v-model="order.order_date"
                            label="주문일"
                            placeholder="e.g. 2019-01-01"

                        > </app-input-ex>

                        <app-input-ex
                            class="uk-margin-small-bottom"
                            type="text"

                            v-model="order.order_url"
                            label="주문URL(도메인)"
                            placeholder="e.g. amazon.com"

                        > </app-input-ex>

                        <app-input-ex
                            class="uk-margin-small-bottom"
                            type="text"

                            v-model="order.order_email"
                            label="주문이메일"
                            placeholder="e.g. 해외사이트의 오더메일을 수신할 이메일"

                        > </app-input-ex>

                        <app-input-ex
                            class="uk-margin-small-bottom"
                            type="text"

                            v-model="order.order_id"
                            label="주문ID"
                            placeholder="e.g. 해외사이트의 ID"

                        > </app-input-ex>
                    </div>

                    <div class="uk-width-medium uk-margin-right">
                        <!-- 배송지 -->
                        <app-input-ex
                            class="uk-margin-small-bottom"
                            type="radio"
                            :options="shippingCenterOptions"

                            v-model="order.shipping_center"
                            label="배송지"
                            placeholder=""
                        > </app-input-ex>
                    </div>

                    <div class="uk-width-medium">


                        <!-- 결제정보 -->
                        <app-input-ex
                            class="uk-margin-small-bottom"
                            type="writable-select"
                            :options="paymentMethodOptions"

                            v-model="order.payment_method"
                            label="결제방법(카드)"
                            placeholder=""
                        > </app-input-ex>

                        <app-input-ex
                            class="uk-margin-small-bottom"
                            type="text"

                            v-model="order.payment_price"
                            label="결제금액"
                            :placeholder="regionCurrency"
                        > </app-input-ex>

                        <app-input-ex
                            class="uk-margin-small-bottom"
                            type="textarea"
                            :textarea-rows="5"

                            v-model="order.payment_memo"
                            label="결제추가정보"
                            placeholder="배송비, TAX, 프로모션등의 내용을 기록"
                        > </app-input-ex>
                    </div>
                </div>





            </div>


            <div class="uk-modal-footer uk-text-right">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    완료
                </button>
            </div>
        </div>
    </div>
</template>

<script>


    export default {
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                /**
                 * (int) 지역ID
                 */
                regionId: null,

                /**
                 * (int) 영업소ID
                 */
                agentId: null,

                /**
                 * (int) 사용자ID
                 */
                userId: null,

                /**
                 * (object) 오더정보
                 */
                order: {},

                /**
                 * (array) 배송지 옵션
                 */
                shippingCenterOptions: [],

                /**
                 * (array) payment_method 옵션
                 */
                paymentMethodOptions: [],

                /**
                 * (string) 지역 화폐단위
                 */
                regionCurrency: null,
            };
        },
        computed: {

        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             */
            form(region_id, agent_id, user_id) {

                // 리소스ID 저장
                this.regionId = region_id;
                this.agentId = agent_id;
                this.userId = user_id;

                // 옵션정보 조회하기
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/regions/'+this.regionId+'/agents/'+this.agentId+'/users/'+this.userId+'/init-to-buy-order',
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    // 옵션정보 저장
                    this.shippingCenterOptions = response.shipping_center_options;
                    this.paymentMethodOptions = response.payment_method_options;
                    this.regionCurrency = response.region_currency;

                    // 배송지 선택안함 옵션 추가
                    this.shippingCenterOptions.unshift({
                        text: '선택안함',
                        val: '',
                    });

                    // 입력값 초기화
                    this.order = {
                        buy_order_code: null,
                        order_date: null,
                        order_url: null,
                        order_email: null,
                        order_id: null,

                        shipping_center: '',

                        payment_method: null,
                        payment_memo: null,
                        payment_price: null,
                    };

                    // 폼띄우기
                    this.displayForm();
                });



            },

            /**
             * submit
             */
            submit() {

                // ajax 옵션
                let opts = {
                    type: 'post',
                    url: '/buy-orders',
                    data: _.merge({
                        '_token': this.csrfToken,
                        'region_id': this.regionId,
                        'agent_id': this.agentId,
                        'user_id': this.userId,
                    }, this.order),

                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>